import { useMemo } from 'react';

import { canEditZones } from '@/config/zone-permissions';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Whether the signed-in user may create / edit / delete zones and paint cells.
 * Managing a zone's mitra roster is not gated — see `config/zone-permissions`.
 */
export const useCanEditZones = (): boolean => {
  const { user } = useAuth();
  return useMemo(() => canEditZones(user?.email), [user?.email]);
};
